import { Grid, styled } from '@mui/material';

interface IDashBoardGridProps {
  height?: number;
}

export default styled(Grid)(({ height }: IDashBoardGridProps) => ({
  borderRadius: '7.6px',
  width: '100%',
  overflow: 'auto',
  position: 'relative',
  height: height ? `${height}px` : 'auto',
}));
